import React, { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import { useMetadata } from '../../../providers/MetadataContext';

function InvestorDetailsSourceOfFundsField({ value, setValue }) {
  const metadata = useMetadata();
  const [selected, setSelected] = useState(
    (metadata?.user?.lists?.sources_of_funds || []).find(
      (option) => option.entity_id === value
    )
  );

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    setValue(newValue?.entity_id);
  };

  return (
    <Box>
      <Autocomplete
        id='source-of-funds-field'
        options={metadata?.user?.lists?.sources_of_funds || []}
        value={selected}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        renderInput={(params) => (
          <TextField {...params} label='Source of Funds' />
        )}
      />
    </Box>
  );
}

export default InvestorDetailsSourceOfFundsField;
